export default __webpack_public_path__ + "static/media/arrow-up.f5ed4dc2.svg";